import { AnimatePresence, motion } from 'motion/react';
import type { HTMLAttributes } from 'react';
import { Flex } from '../Flex/Flex';
import type { TextType } from '../Text/BaseText';
import { Text } from '../Text/Text';

export interface OdometerProps extends HTMLAttributes<HTMLDivElement> {
  readonly text: string;
  readonly textType?: TextType;
  readonly textClassName?: string;
  readonly transition?: {
    readonly duration?: number;
    readonly staggerDelay?: number;
  };
  readonly swapMode?: 'char' | 'text';
}

const DEFAULT_DURATION = 0.1;
const DEFAULT_STAGGER_DELAY = 0.05;

export const Odometer: React.FC<OdometerProps> = ({
  text = '',
  textClassName,
  textType,
  transition: { duration = DEFAULT_DURATION, staggerDelay = DEFAULT_STAGGER_DELAY } = {
    duration: DEFAULT_DURATION,
    staggerDelay: DEFAULT_STAGGER_DELAY,
  },
  swapMode = 'text',
  ...props
}) => {
  return (
    <Flex overflow="hidden" position="relative" {...props}>
      <AnimatePresence initial={false} mode="popLayout">
        {text.split('').map((char, index) => (
          <motion.span
            animate={{
              y: '0%',
              transition: {
                duration: duration,
                delay: staggerDelay * index,
              },
            }}
            exit={{
              y: '-100%',
              transition: {
                duration: duration,
                delay: staggerDelay * index,
              },
            }}
            initial={{ y: '100%' }}
            // eslint-disable-next-line react/no-array-index-key
            key={`${swapMode === 'text' ? text : char}-${index}`}
          >
            <Text className={textClassName} type={textType}>
              {char}
            </Text>
          </motion.span>
        ))}
      </AnimatePresence>
    </Flex>
  );
};
